<template>
  <button
    class="rounded-3xl border border-white py-1 px-2 cursor-pointer hover:bg-tw-orange-bright hover:text-black"
    @click="setLanguage()"
    @touchstart.prevent="setLanguage()"
  >
    {{ languageName }}
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue'

  import useCommonStore from '@/composables/common'

  const common = useCommonStore()

  const languageName = computed(() => {
    return common.getters.languageCode.value === 'no' ? `Norsk` : `English`
  })

  function setLanguage() {
    common.actions.setLanguageCode()
  }
</script>

<style scoped></style>
